var _path, _path2, _path3, _circle, _circle2, _path4, _path5, _path6, _circle3, _circle4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClipboard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_44027",
    "data-name": "Group 44027",
    xmlns: "http://www.w3.org/2000/svg",
    width: 200.027,
    height: 195.251,
    viewBox: "0 0 200.027 195.251",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_377467",
    "data-name": "Path 377467",
    d: "M430.222,197.315h-53.9a4.638,4.638,0,0,0-4.633,4.633v119.79l-.618.188-13.222,4.049a2.473,2.473,0,0,1-3.085-1.64l-39.33-128.469a2.472,2.472,0,0,1,1.64-3.086l20.375-6.239,59.069-18.081,20.375-6.239a2.468,2.468,0,0,1,3.086,1.637L430.034,196.7Z",
    transform: "translate(-303.237 -153.405)",
    fill: "#f2f2f2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_377468",
    "data-name": "Path 377468",
    d: "M414.93,177.209l-12.116-39.577a5.249,5.249,0,0,0-6.557-3.484l-28.647,8.768L308.544,161,279.9,169.772a5.255,5.255,0,0,0-3.484,6.557l41.412,135.258a5.259,5.259,0,0,0,5.022,3.716,5.185,5.185,0,0,0,1.535-.232l19.637-6.01.618-.191v-.646l-.618.188L324.2,314.481a4.637,4.637,0,0,1-5.785-3.073L277.006,176.147a4.627,4.627,0,0,1,3.073-5.785l28.647-8.772,59.066-18.081,28.646-8.772a4.628,4.628,0,0,1,5.785,3.073l12.061,39.4.192.618h.642Z",
    transform: "translate(-276.183 -133.917)",
    fill: "#3f3d56"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_377469",
    "data-name": "Path 377469",
    d: "M383.735,182.987a2.785,2.785,0,0,1-2.66-1.966L377.1,168.027a2.779,2.779,0,0,1,1.844-3.472l54.34-16.636a2.782,2.782,0,0,1,3.472,1.844l3.978,12.994a2.783,2.783,0,0,1-1.844,3.472l-54.34,16.636a2.772,2.772,0,0,1-.812.122Z",
    transform: "translate(-345.844 -143.51)",
    fill: "#fff5cc"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3793",
    "data-name": "Ellipse 3793",
    cx: 6.177,
    cy: 6.177,
    r: 6.177,
    transform: "translate(52.553 1.529)",
    fill: "#fff5cc"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3794",
    "data-name": "Ellipse 3794",
    cx: 3.912,
    cy: 3.912,
    r: 3.912,
    transform: "translate(54.818 3.795)",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_377470",
    "data-name": "Path 377470",
    d: "M639.338,424.425H534.944a2.628,2.628,0,0,1-2.625-2.625V296.712a2.628,2.628,0,0,1,2.625-2.625H639.338a2.628,2.628,0,0,1,2.625,2.625V421.8A2.628,2.628,0,0,1,639.338,424.425Z",
    transform: "translate(-453.209 -244.617)",
    fill: "#e6e6e6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_377471",
    "data-name": "Path 377471",
    d: "M566.083,274.087H501.069a5.258,5.258,0,0,0-5.251,5.251V405.29l.618-.188V279.337a4.638,4.638,0,0,1,4.633-4.633h65.206Zm56.675,0H501.069a5.258,5.258,0,0,0-5.251,5.251V420.794a5.258,5.258,0,0,0,5.251,5.251h121.69a5.258,5.258,0,0,0,5.25-5.251V279.337A5.258,5.258,0,0,0,622.759,274.087Zm4.633,146.707a4.638,4.638,0,0,1-4.633,4.633H501.069a4.638,4.638,0,0,1-4.633-4.633V279.337a4.638,4.638,0,0,1,4.633-4.633h121.69a4.638,4.638,0,0,1,4.633,4.633Z",
    transform: "translate(-427.982 -230.794)",
    fill: "#3f3d56"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_377472",
    "data-name": "Path 377472",
    d: "M668.428,275.236H611.6a2.783,2.783,0,0,1-2.78-2.78v-13.59a2.783,2.783,0,0,1,2.78-2.78h56.83a2.783,2.783,0,0,1,2.78,2.78v13.59A2.783,2.783,0,0,1,668.428,275.236Z",
    transform: "translate(-506.081 -218.354)",
    fill: "#fff5cc"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3795",
    "data-name": "Ellipse 3795",
    cx: 6.177,
    cy: 6.177,
    r: 6.177,
    transform: "translate(127.754 26.305)",
    fill: "#fff5cc"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3796",
    "data-name": "Ellipse 3796",
    cx: 3.762,
    cy: 3.762,
    r: 3.762,
    transform: "translate(130.169 28.72)",
    fill: "#fff"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClipboard);
export default __webpack_public_path__ + "static/media/clipboard.3a7c7c2182a93d709036ba6ff13cebfc.svg";
export { ForwardRef as ReactComponent };